import { FunctionComponent } from "react";
import { Survey } from "survey-react-ui";

import { FormApiOutput, FormStatusEnum } from "../hooks/useFormApi.types";
import { CompletedSurvey } from "./CompletedSurvey";
import { InvalidRequest } from "./InvalidRequest";
import { Loading } from "./Loading";
import { QrCode } from "./QrCode";
import { VerifyPinForm } from "./VerifyPinForm/VerifyPinForm";

export const SurveyRendererInner: FunctionComponent<FormApiOutput> = ({
  form,
  formId,
  status,
  expiry,
  description,
  helpText,
  isReadOnly,
  documentDownloadCallBackUrl,
  submitPin
}) => {
  switch (status) {
    case FormStatusEnum.Initialising:
      return <h3>Initialising</h3>;
    case FormStatusEnum.QrCode:
      return <QrCode />;
    case FormStatusEnum.Available:
      const css = {
        title: "bp-title",
        description: "bp-description",
        titleOnAnswer: "bp-title-question-answered",
        page: "bp-page",
        question: {
          titleOnAnswer: "bp-title-question-answered",
          title: "bp-question-title",
          requiredText: "bp-required-text"
        }
      };

      return <Survey model={form} css={css} />;
    case FormStatusEnum.Loading:
      return <Loading />;
    case FormStatusEnum.Completed:
      return (
        <CompletedSurvey
          isReadOnly={isReadOnly}
          formId={formId}
          documentDownloadCallBackUrl={documentDownloadCallBackUrl}
          expiry={expiry}
        />
      );
    case FormStatusEnum.AlreadyCompleted:
      if (isReadOnly && documentDownloadCallBackUrl) {
        return (
          <CompletedSurvey
            formId={formId}
            isReadOnly={isReadOnly}
            documentDownloadCallBackUrl={documentDownloadCallBackUrl}
            expiry={expiry}
          />
        );
      } else {
        return <InvalidRequest description={description} helpText={helpText} />;
      }
    case FormStatusEnum.PinRequired:
      return <VerifyPinForm submitPin={submitPin} />;
    case FormStatusEnum.NotFound:
    case FormStatusEnum.Expired:
    case FormStatusEnum.DecodeError:
    default:
      return <InvalidRequest description={description} helpText={helpText} />;
  }
};
